import { ChangeDetectionStrategy, Component, computed, contentChild, inject, input } from '@angular/core';
import { LinkComponent } from '../../basic/link/link.component';
import { PageCommandGroupComponent } from '../../misc/page-command-group/page-command-group.component';
import { PageCommand, PageCommandType } from '../../misc/page-command/page-command.component';
import { CurrentUserService } from 'src/app/user/services';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  imports: [LinkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PageHeaderComponent {
  private currentUserService = inject(CurrentUserService);
  commandGroup = contentChild(PageCommandGroupComponent);
  title = input.required();

  inputCommands = computed(() => this.commandGroup()?.commands() ?? []);

  //These are the default commands with a fixed position, text and icon.
  defaultPageCommands: PageCommand[] = [
    { name: 'new', text: 'New', icon: 'dx-icon-add', action: () => {}, type: PageCommandType.Primary, requiredPermissions: [], disabled: false },
    { name: 'edit', text: 'Edit', icon: 'dx-icon-edit', action: () => {}, type: PageCommandType.Primary, requiredPermissions: [], disabled: false },
    { name: 'save', text: 'Save', icon: 'dx-icon-save', action: () => {}, type: PageCommandType.Primary, requiredPermissions: [], disabled: false },
    { name: 'cancel', text: 'Cancel', icon: 'dx-icon-revert', action: () => {}, type: PageCommandType.Primary, requiredPermissions: [], disabled: false },
    { name: 'delete', text: 'Delete', icon: 'dx-icon-trash', action: () => {}, type: PageCommandType.Primary, requiredPermissions: [], disabled: false },
    { name: 'refresh', text: 'Refresh', icon: 'dx-icon-refresh', action: () => {}, type: PageCommandType.Primary, requiredPermissions: [], disabled: false },
    { name: 'showlog', text: 'Show log', icon: 'dx-icon-belloutline', action: () => {}, type: PageCommandType.Primary, requiredPermissions: [], disabled: false },
  ];

  visiblePageCommands = computed(() => {
    let visibleDefaultPageCommands = this.defaultPageCommands.filter(defaultCommand => this.inputCommands().some(inputCommand => inputCommand.name === defaultCommand.name));
    visibleDefaultPageCommands = visibleDefaultPageCommands.map(defaultPageCommand => {
      const inputCommand = this.inputCommands().find(command => command.name === defaultPageCommand.name);
      let vissibleCommand = defaultPageCommand;
      vissibleCommand = inputCommand?.action ? { ...vissibleCommand, action: inputCommand.action } : vissibleCommand;
      vissibleCommand = inputCommand?.requiredPermissions ? { ...vissibleCommand, requiredPermissions: inputCommand.requiredPermissions } : vissibleCommand;
      vissibleCommand = inputCommand?.disabled !== undefined ? { ...vissibleCommand, disabled: inputCommand.disabled } : vissibleCommand;
      return vissibleCommand;
    });

    const customCommands = this.inputCommands().filter(inputCommand => !visibleDefaultPageCommands.some(defaultCommand => defaultCommand.name === inputCommand.name));

    return [ ...visibleDefaultPageCommands, ...customCommands];
  });

  hasPermission(p: string[]) {
    if (p.length > 0) {
      const foundPermissions = p.filter(permission => this.currentUserService.hasPermission(permission));
      return foundPermissions.length > 0;
    }
    else {
      return true;
    }
  }
}